import React, { useState } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import { Button, withStyles } from '@material-ui/core';
import { useDataProvider, useNotify } from 'react-admin';
import ConfirmationModal from '../../../../../components/ConfirmationModal';

const styles = {
  button: {
    color: 'red',
  },
};

const DeleteButton = ({ classes, resource, record: { id, name }, onSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const handleConfirm = async() => {
    setIsLoading(true);
    try {
      await dataProvider.delete(resource, { id });
      notify('Consent item has been successfully deleted.', 'info');
      setIsModalOpen(false);
      onSuccess();
    } catch (error) {
      notify(error.message, 'warning');
    }
    setIsLoading(false);
  };
  return (
    <>
      <Button
        className={classes.button}
        variant="text"
        startIcon={<DeleteIcon/>}
        onClick={() => setIsModalOpen(true)}>
        Delete
      </Button>
      <ConfirmationModal
        open={isModalOpen}
        cancelText="cancel"
        okText="yes"
        onOk={handleConfirm}
        loading={isLoading}
        title={`Are you sure you want to delete consent item ${name}?`}
        onCancel={() => setIsModalOpen(false)}
      />
    </>);
};

export default withStyles(styles)(DeleteButton);
